// СГЕНЕРИРОВАНО генератором миссий (developer_artifacts/scripts/missionGen).
// Правится не руками, а перегенерацией: npx tsx developer_artifacts/scripts/missionGen/generate_humans_1.cjs
/* eslint-disable */
const mission = {
  "id": "humans_1",
  "campaignFactionId": "humans",
  "order": 1,
  "title": "Волчье золото",
  "shortTitle": "Миссия I",
  "description": "Верни Риму рудничный посёлок Виктимулы у приисков Бессы",
  "finalRound": 10,
  "reward": {
    "type": "chest",
    "chestId": "chest_silver"
  },
  "rewardIfFactionOwned": null,
  "playerColor": "blue",
  "players": [
    {
      "name": "Луций",
      "color": "blue",
      "factionId": "humans",
      "selectedSkin": "humans_default",
      "isBot": false,
      "bonus": "none"
    },
    {
      "name": "Кесорикс",
      "color": "celadon",
      "factionId": "humans",
      "selectedSkin": "humans_default",
      "isBot": true,
      "bonus": "none"
    }
  ],
  "field": {
    "hexes": {
      "-9,-6": "sea",
      "-9,-5": "sea",
      "-9,-4": "sea",
      "-10,-3": "sea",
      "-10,-2": "sea",
      "-10,-1": "sea",
      "-10,0": "sea",
      "-11,1": "sea",
      "-11,2": "sea",
      "-11,3": "sea",
      "-10,3": "sea",
      "-10,4": "sea",
      "-10,5": "sea",
      "-10,6": "sea",
      "-9,6": "sea",
      "-9,7": "sea",
      "-9,8": "sea",
      "-8,8": "sea",
      "-8,9": "sea",
      "-7,9": "sea",
      "-7,10": "sea",
      "-6,10": "sea",
      "-6,11": "sea",
      "-5,11": "sea",
      "-5,12": "sea",
      "-4,12": "sea",
      "-4,-9": "mountain",
      "-4,-8": "mountain",
      "-4,-7": "mountain",
      "-3,-10": "mountain",
      "-3,-9": "mountain",
      "-3,-8": "mountain",
      "-3,-7": "mountain",
      "-2,-11": "mountain",
      "-2,-10": "mountain",
      "-2,-9": "mountain",
      "-2,-8": "mountain",
      "-2,-7": "mountain",
      "-1,-11": "mountain",
      "-1,-10": "mountain",
      "-1,-9": "mountain",
      "-1,-8": "mountain",
      "0,-11": "mountain",
      "0,-10": "mountain",
      "0,-9": "mountain",
      "2,-10": "mountain",
      "2,-9": "mountain",
      "2,-8": "mountain",
      "3,-11": "mountain",
      "3,-10": "mountain",
      "3,-9": "mountain",
      "3,-8": "mountain",
      "4,-12": "mountain",
      "4,-11": "mountain",
      "4,-10": "mountain",
      "4,-9": "mountain",
      "4,-8": "mountain",
      "5,-12": "mountain",
      "5,-11": "mountain",
      "5,-10": "mountain",
      "5,-9": "mountain",
      "6,-12": "mountain",
      "6,-11": "mountain",
      "6,-10": "mountain",
      "8,-9": "mountain",
      "8,-8": "mountain",
      "9,-10": "mountain",
      "9,-9": "mountain",
      "9,-8": "mountain",
      "10,-10": "mountain",
      "10,-9": "mountain",
      "-7,11": "mountain",
      "-6,9": "mountain",
      "-5,9": "mountain",
      "-5,10": "mountain",
      "0,9": "mountain",
      "0,10": "mountain",
      "0,11": "mountain",
      "1,8": "mountain",
      "1,9": "mountain",
      "1,10": "mountain",
      "1,11": "mountain",
      "2,7": "mountain",
      "2,8": "mountain",
      "2,9": "mountain",
      "2,10": "mountain",
      "2,11": "mountain",
      "3,7": "mountain",
      "3,8": "mountain",
      "3,9": "mountain",
      "3,10": "mountain",
      "4,7": "mountain",
      "4,8": "mountain",
      "4,9": "mountain",
      "-7,1": "flag_blue",
      "-8,2": "quarter",
      "-6,0": "quarter",
      "-7,2": "farm",
      "-8,1": "barracks",
      "-5,1": "road",
      "-4,1": "road",
      "-3,1": "road",
      "-2,0": "road",
      "-1,0": "road",
      "-6,1": "road",
      "0,0": "mine",
      "1,-1": "super_mine",
      "0,-1": "ruins",
      "2,0": "ruins",
      "2,-2": "ruins",
      "-1,-1": "mountain",
      "-1,1": "mountain",
      "1,1": "farm",
      "0,2": "farm",
      "-1,2": "farm",
      "5,0": "flag_celadon",
      "4,1": "quarter",
      "6,-1": "quarter",
      "5,-1": "quarter",
      "5,1": "farm",
      "4,-1": "farm",
      "6,0": "farm",
      "4,0": "barracks",
      "3,0": "road",
      "3,1": "ruins",
      "9,-4": "road",
      "10,-5": "road",
      "11,-5": "road",
      "12,-6": "road",
      "13,-6": "road",
      "14,-7": "road",
      "11,-6": "road",
      "12,-5": "road",
      "10,-6": "mountain",
      "11,-4": "mountain",
      "-14,0": "sea",
      "-14,3": "sea",
      "-14,6": "sea",
      "-14,9": "sea",
      "-14,12": "sea",
      "-13,-1": "sea",
      "-12,14": "sea",
      "-10,-4": "sea",
      "-9,14": "sea",
      "-7,-7": "sea",
      "-6,14": "sea",
      "-4,-10": "sea",
      "-3,14": "sea",
      "-1,-13": "sea",
      "0,14": "sea",
      "2,-14": "sea",
      "3,11": "sea",
      "5,-14": "sea",
      "6,8": "sea",
      "8,-14": "sea",
      "9,5": "sea",
      "11,-14": "sea",
      "12,2": "sea",
      "14,-14": "sea",
      "14,-11": "sea",
      "14,-8": "sea",
      "14,-5": "sea",
      "14,-2": "sea",
      "-16,0": "sea",
      "-16,1": "sea",
      "-16,2": "sea",
      "-16,3": "sea",
      "-16,4": "sea",
      "-16,5": "sea",
      "-16,6": "sea",
      "-16,7": "sea",
      "-16,8": "sea",
      "-16,9": "sea",
      "-16,10": "sea",
      "-16,11": "sea",
      "-16,12": "sea",
      "-16,13": "sea",
      "-16,14": "sea",
      "-16,15": "sea",
      "-16,16": "sea",
      "-15,-1": "sea",
      "-15,16": "sea",
      "-14,-2": "sea",
      "-14,16": "sea",
      "-13,-3": "sea",
      "-13,16": "sea",
      "-12,-4": "sea",
      "-12,16": "sea",
      "-11,-5": "sea",
      "-11,16": "sea",
      "-10,-6": "sea",
      "-10,16": "sea",
      "-9,-7": "sea",
      "-9,16": "sea",
      "-8,-8": "sea",
      "-8,16": "sea",
      "-7,-9": "sea",
      "-7,16": "sea",
      "-6,-10": "sea",
      "-6,16": "sea",
      "-5,-11": "sea",
      "-5,16": "sea",
      "-4,-12": "sea",
      "-4,16": "sea",
      "-3,-13": "sea",
      "-3,16": "sea",
      "-2,-14": "sea",
      "-2,16": "sea",
      "-1,-15": "sea",
      "-1,16": "sea",
      "0,-16": "sea",
      "0,16": "sea",
      "1,-16": "sea",
      "1,15": "sea",
      "2,-16": "sea",
      "2,14": "sea",
      "3,-16": "sea",
      "3,13": "sea",
      "4,-16": "sea",
      "4,12": "sea",
      "5,-16": "sea",
      "5,11": "sea",
      "6,-16": "sea",
      "6,10": "sea",
      "7,-16": "sea",
      "7,9": "sea",
      "8,-16": "sea",
      "8,8": "sea",
      "9,-16": "sea",
      "9,7": "sea",
      "10,-16": "sea",
      "10,6": "sea",
      "11,-16": "sea",
      "11,5": "sea",
      "12,-16": "sea",
      "12,4": "sea",
      "13,-16": "sea",
      "13,3": "sea",
      "14,-16": "sea",
      "14,2": "sea",
      "15,-16": "sea",
      "15,1": "sea",
      "16,-16": "sea",
      "16,-15": "sea",
      "16,-14": "sea",
      "16,-13": "sea",
      "16,-12": "sea",
      "16,-11": "sea",
      "16,-10": "sea",
      "16,-9": "sea",
      "16,-8": "sea",
      "16,-7": "sea",
      "16,-6": "sea",
      "16,-5": "sea",
      "16,-4": "sea",
      "16,-3": "sea",
      "16,-2": "sea",
      "16,-1": "sea",
      "16,0": "sea"
    },
    "units": [
      {
        "id": "u_celadon_0_4_1",
        "hexKey": "4,1",
        "ownerId": "player_id_celadon",
        "type": "unit_d6",
        "size": 3,
        "maxSize": 3
      },
      {
        "id": "u_celadon_1_6_-1",
        "hexKey": "6,-1",
        "ownerId": "player_id_celadon",
        "type": "unit_d6",
        "size": 2,
        "maxSize": 2
      },
      {
        "id": "u_celadon_2_5_-1",
        "hexKey": "5,-1",
        "ownerId": "player_id_celadon",
        "type": "unit_d6",
        "size": 2,
        "maxSize": 2
      }
    ],
    "specialBuildings": {
      "-8,2": "warehouse"
    },
    "gridConfig": {
      "radius": 20,
      "hexSize": 60,
      "orientation": "flat"
    }
  },
  "policyMarket": [
    {
      "id": "militarism",
      "name": "Милитаризм",
      "description": "Увеличенный урон в ближнем бою",
      "implemented": true,
      "color": "#98172d"
    },
    {
      "id": "patriotism",
      "name": "Патриотизм",
      "description": "Скидка на найм размера отрядов и Арсенал",
      "implemented": true,
      "color": "#98172d"
    },
    {
      "id": "agrarianism",
      "name": "Аграризм",
      "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
      "implemented": true,
      "color": "#D68A5A"
    },
    {
      "id": "fortificationism",
      "name": "Фортификационизм",
      "description": "Мгновенное строительство и скидка для крепостей\nБонус к урону рядом с крепостью",
      "implemented": true,
      "color": "#865333"
    },
    {
      "id": "industrialism",
      "name": "Индустриализм",
      "description": "Дополнительное действие\nв фазе Строительства\nСкидка на особые строения",
      "implemented": true,
      "color": "#865333"
    },
    {
      "id": "oligarchy",
      "name": "Олигархия",
      "description": "2 гильдий в одном городе\nУвеличенный доход гильдий",
      "implemented": true,
      "color": "#DEA806"
    }
  ],
  "script": [
    {
      "id": "e_0_replica",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "«Луций. Ты спрашиваешь, как понять, что решение верное. Запомни: у легата не бывает верных решений. Бывают решения, за которые он готов ответить. Рим не требует от нас быть правыми — Рим требует отвечать. Остальное — философия, а философию оставь грекам. — М. Аврелий Скавр, сыну»",
        "characterName": "Из писем отца",
        "side": "left",
        "characterImage": "/img/campaigns/humans/letters_marc.png"
      }
    },
    {
      "id": "e_1_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h1_capture_victimulae",
        "type": "capture_city",
        "params": {
          "centralHexKey": "5,0"
        },
        "text": "Отбей Виктимулы",
        "isMain": true,
        "isFailure": false
      }
    },
    {
      "id": "e_2_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h1_hold_out",
        "type": "survive_rounds",
        "params": {
          "rounds": 10
        },
        "text": "Продержись до конца сцены",
        "isMain": true,
        "isFailure": false
      }
    },
    {
      "id": "e_3_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h1_units",
        "type": "units_count",
        "params": {
          "amount": 3
        },
        "text": "Собери войско в Верцеллах и держи в строю: три отряда (потери восполняй в казарме)",
        "isMain": false,
        "isFailure": false
      }
    },
    {
      "id": "e_4_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h1_mine",
        "type": "capture_key_point",
        "params": {
          "hexKey": "0,0"
        },
        "text": "Присоедини рудник Бессы: центральный квартал (4 монеты) на площадке у отвалов. Лагерь заберёт и огороды промывальщиков — без них обоз не дотянет до посёлка",
        "isMain": false,
        "isFailure": false
      }
    },
    {
      "id": "entry_5_SET_STARTING_QUARTER",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "SET_STARTING_QUARTER",
        "payload": {
          "playerId": "player_id_celadon",
          "hexKey": "5,0"
        }
      }
    },
    {
      "id": "entry_6_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 0,
          "currentPlayerId": "player_id_celadon",
          "phase": "setup",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_7_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "oligarchy",
            "name": "Олигархия",
            "description": "2 гильдий в одном городе\nУвеличенный доход гильдий",
            "implemented": true,
            "color": "#DEA806"
          },
          "round": 0,
          "currentPlayerId": "player_id_celadon",
          "phase": "setup",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "e_8_objective",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h1_lose_vercellae",
        "type": "lose_city",
        "params": {
          "centralHexKey": "-7,1"
        },
        "text": "Не потеряй Верцеллы",
        "isMain": false,
        "isFailure": true
      }
    },
    {
      "id": "e_9_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Легат Аврелий! Какая честь, какая… своевременная честь. Гай Салоний, смотритель рудничного округа — от откупной компании, но здешние зовут префектом, и я, каюсь, привык. Двадцать лет держу для Рима этот угол. Рудник, стало быть, вернуть? Верное дело. Казна пуста, посёлок захвачен, старатели разбежались — но в остальном у нас, хвала богам, полный порядок.",
        "characterName": "Салоний",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m1_salonius_fuss.png"
      }
    },
    {
      "id": "e_10_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Сенату нужно золото Бессы, префект. Мне нужны люди. Приказ о наборе у тебя в руках — читай не шевеля губами, быстрее выйдет.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m1_lucius_stern.png"
      }
    },
    {
      "id": "e_11_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Люди найдутся, как не найтись… Ветераны с наделов, охрана подрядов, сыновья должников — этих даром отдам, то есть… почти даром. Кормить, одевать, хоронить — всё за счёт казны, разумеется. Городской.",
        "characterName": "Салоний",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m1_salonius_fuss.png"
      }
    },
    {
      "id": "e_12_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Он ворует, мальчик. Но смотри, ЧТО он ворует: с хлеба — да, с подковных гвоздей — да. Со стен и с колодцев — нет. Такой вор в осаде полезнее двух честных.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m1_barba_grin.png"
      }
    },
    {
      "id": "e_13_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Центурион Секст Атилий, легат. Пятнадцать лет выслуги, Македония, Африка. Мне велено передать когорту под твоё… командование. Разреши исполнять.",
        "characterName": "Атилий",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m1_atilius_formal.png"
      }
    },
    {
      "id": "e_14_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Исполняй, центурион. И, Атилий, — паузу между «твоё» и «командование» в следующий раз сократи. Она — единственное, что у тебя не по уставу.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m1_lucius_stern.png"
      }
    },
    {
      "id": "e_15_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Огрызается. Хорошо. Марк в его годы тоже сначала огрызался, потом думал… К сорока научился наоборот. Не дожил доучиться.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m1_barba_grin.png"
      }
    },
    {
      "id": "entry_16_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "u_celadon_0_4_1",
          "unitHexKey": "4,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_17_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_celadon_1_6_-1",
          "unitHexKey": "6,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_18_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,-1",
          "unitId": "u_celadon_2_5_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_19_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_celadon",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_20_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "ecoanarchism",
            "name": "Экоанархизм",
            "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
            "implemented": true,
            "color": "#D68A5A"
          },
          "round": 1,
          "currentPlayerId": "player_id_celadon",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_21_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 1,
        "phase": "construction",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_celadon",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_22_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 1,
        "phase": "construction",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "agrarianism",
            "name": "Аграризм",
            "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
            "implemented": true,
            "color": "#D68A5A"
          },
          "round": 1,
          "currentPlayerId": "player_id_celadon",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_23_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "celadon"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_24_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "celadon"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_25_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_26_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_27_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 1,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_28_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "oligarchy",
            "name": "Олигархия",
            "description": "2 гильдий в одном городе\nУвеличенный доход гильдий",
            "implemented": true,
            "color": "#DEA806"
          },
          "round": 1,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_29_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "u_celadon_0_4_1",
          "unitHexKey": "4,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_30_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_celadon_1_6_-1",
          "unitHexKey": "6,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_31_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,-1",
          "unitId": "u_celadon_2_5_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_32_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_celadon",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_33_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "agrarianism",
            "name": "Аграризм",
            "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
            "implemented": true,
            "color": "#D68A5A"
          },
          "round": 2,
          "currentPlayerId": "player_id_celadon",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_34_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_celadon",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_35_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "oligarchy",
            "name": "Олигархия",
            "description": "2 гильдий в одном городе\nУвеличенный доход гильдий",
            "implemented": true,
            "color": "#DEA806"
          },
          "round": 2,
          "currentPlayerId": "player_id_celadon",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_36_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "celadon"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_37_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "celadon"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_38_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_39_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_40_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 2,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_41_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "hegemonism",
            "name": "Гегемонизм",
            "description": "Бонус к доходу очков и урону в центре поля",
            "implemented": true,
            "color": "#A9A9A9"
          },
          "round": 2,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "e_42_replica",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Гряды видишь, легат? Огороды промывальщиков. Хлеб на приисках свой: от города обоз сюда не доходит — далеко. Станешь лагерем у отвалов — гряды твои, будет чем кормить людей. Не станешь — дальше пойдёшь на пустой телеге, а на пустой телеге посёлков не берут.",
        "characterName": "Старатель-проводник",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m1_miner.png"
      }
    },
    {
      "id": "e_43_replica",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Вон за теми отвалами Виктимулы, легат. Только ты это… странное скажу. Я у посёлка третьего дня был, ночью, за инструментом своим ходил. Там триста душ набилось, а ТИХО. Ни песни, ни ругани, ни дитё не заплачет. Триста душ — и тихо, как в погребе.",
        "characterName": "Старатель-проводник",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m1_miner.png"
      }
    },
    {
      "id": "e_44_replica",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "След смотри, легат. Шире моей ладони, и вдавлен — на два пальца. Через отвал шёл, не в обход. Медведь?",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m1_barba_grim.png"
      }
    },
    {
      "id": "e_45_replica",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Медведь в сапогах, Квинт?",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m1_lucius_stern.png"
      }
    },
    {
      "id": "e_46_replica",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Вот и я говорю. Пойдём. Не люблю загадки, у которых такие ноги.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m1_barba_grim.png"
      }
    },
    {
      "id": "entry_47_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "u_celadon_0_4_1",
          "unitHexKey": "4,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_48_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_celadon_1_6_-1",
          "unitHexKey": "6,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_49_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,-1",
          "unitId": "u_celadon_2_5_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_50_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_celadon",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_51_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "isolationism",
            "name": "Изоляционизм",
            "description": "Защита права первого хода\nСкидка на особые строения\nБонус к урону отрядов в своих городах",
            "implemented": true,
            "color": "#b09292"
          },
          "round": 3,
          "currentPlayerId": "player_id_celadon",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_52_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 3,
        "phase": "construction",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_celadon",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_53_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 3,
        "phase": "construction",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "barbarism",
            "name": "Варварство",
            "description": "Бесплатный наем Пехоты\nУвеличенный урон в ближнем бою\nОчки за урон",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 3,
          "currentPlayerId": "player_id_celadon",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_54_RECRUIT_UNIT",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "celadon"
      },
      "action": {
        "type": "RECRUIT_UNIT",
        "payload": {
          "hexKey": "4,0",
          "unitType": "unit_d6",
          "factionId": "humans",
          "price": 2,
          "unitId": "rec_celadon_3_4_0"
        }
      }
    },
    {
      "id": "entry_55_ADD_PENDING_RECRUITMENT_ACTION",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "celadon"
      },
      "action": {
        "type": "ADD_PENDING_RECRUITMENT_ACTION",
        "payload": {
          "unitId": "rec_celadon_3_4_0",
          "actionType": "UNIT_RECRUITMENT",
          "quarterHexKey": "4,0",
          "price": 2,
          "sizeAdded": 0
        }
      }
    },
    {
      "id": "entry_56_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "celadon"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_57_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "celadon"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_58_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_59_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_60_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 3,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_61_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "patriotism",
            "name": "Патриотизм",
            "description": "Скидка на найм размера отрядов и Арсенал",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 3,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_62_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "u_celadon_0_4_1",
          "unitHexKey": "4,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_63_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_celadon_1_6_-1",
          "unitHexKey": "6,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_64_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,-1",
          "unitId": "u_celadon_2_5_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_65_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_celadon",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_66_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "ecoanarchism",
            "name": "Экоанархизм",
            "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
            "implemented": true,
            "color": "#D68A5A"
          },
          "round": 4,
          "currentPlayerId": "player_id_celadon",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_67_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 4,
        "phase": "construction",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_celadon",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_68_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 4,
        "phase": "construction",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "hegemonism",
            "name": "Гегемонизм",
            "description": "Бонус к доходу очков и урону в центре поля",
            "implemented": true,
            "color": "#A9A9A9"
          },
          "round": 4,
          "currentPlayerId": "player_id_celadon",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_69_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "celadon"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_70_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "celadon"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_71_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_72_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_73_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 4,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_74_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "servarianism",
            "name": "Серваризм",
            "description": "Увеличенный доход рудников,\nсмежных казармам и крупными отрядам",
            "implemented": true,
            "color": "#DEA806"
          },
          "round": 4,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "e_75_replica",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Стой, римлянин. Я Кесорикс, сын Ботта. Эти люди — мои. Ворота я тебе не открою, но и стрелу первым не пущу. Говори.",
        "characterName": "Кесорикс",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m1_caesorix_proud.png"
      }
    },
    {
      "id": "e_76_replica",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Ты занял посёлок Рима. Верни его — и уводи своих. Это всё, что Рим готов тебе предложить, и больше, чем ты заслужил.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m1_lucius_stern.png"
      }
    },
    {
      "id": "e_77_replica",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Уводить — куда, римлянин? Ты видел карту? Покажи мне на ней место, и я тебе спасибо скажу. На восток? Восток съеден. Мы шли восемь месяцев. Города моего народа горят так, что снег не ложится. С востока пришли звери на двух ногах, ростом с дверь, и они не берут дань, римлянин, — они едят.",
        "characterName": "Кесорикс",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m1_caesorix_proud.png"
      }
    },
    {
      "id": "e_78_replica",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Звери. На двух ногах. Мой отец тоже слышал сказки твоего народа — при Аравсионе, перед тем как ваш царь его повесил. У вас каждый грабёж — бегство, каждое бегство — чудовища. Довольно. Открой ворота.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m1_lucius_stern.png"
      }
    },
    {
      "id": "e_79_replica",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Аравсион… Вот оно что. Тогда мне жаль тебя, сын висевшего. Ты пришёл мстить — а мстить тут некому. Все, кому ты хотел бы мстить, уже мертвы там, на востоке. Мы — это то, что от них осталось. Ломай частокол. Он всё равно строился от воров.",
        "characterName": "Кесорикс",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m1_caesorix_proud.png"
      }
    },
    {
      "id": "e_80_replica",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Заметь, мальчик: он не торговался. Кто хочет жить — торгуется. Он хочет только выбрать, от чего умереть. Мне не нравится, ЧТО у него есть на выбор.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m1_barba_grim.png"
      }
    },
    {
      "id": "entry_81_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "u_celadon_0_4_1",
          "unitHexKey": "4,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_82_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_celadon_1_6_-1",
          "unitHexKey": "6,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_83_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,-1",
          "unitId": "u_celadon_2_5_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_84_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_celadon",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_85_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "totalitarianism",
            "name": "Тоталитаризм",
            "description": "Очки за военные строения\nСкидка на Лагерь и Арсенал\nНайм отрядов увеличенного размера",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 5,
          "currentPlayerId": "player_id_celadon",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_86_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_celadon",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_87_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "servarianism",
            "name": "Серваризм",
            "description": "Увеличенный доход рудников,\nсмежных казармам и крупными отрядам",
            "implemented": true,
            "color": "#DEA806"
          },
          "round": 5,
          "currentPlayerId": "player_id_celadon",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_88_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "celadon"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_89_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "celadon"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_90_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_91_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_92_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 5,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_93_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "despotism",
            "name": "Деспотизм",
            "description": "Скидка на найм отрядов\nСкидка на постройку Лагеря",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 5,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_94_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "u_celadon_0_4_1",
          "unitHexKey": "4,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_95_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_celadon_1_6_-1",
          "unitHexKey": "6,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_96_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,-1",
          "unitId": "u_celadon_2_5_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_97_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_celadon",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_98_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fortificationism",
            "name": "Фортификационизм",
            "description": "Мгновенное строительство и скидка для крепостей\nБонус к урону рядом с крепостью",
            "implemented": true,
            "color": "#865333"
          },
          "round": 6,
          "currentPlayerId": "player_id_celadon",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_99_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_celadon",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_100_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "totalitarianism",
            "name": "Тоталитаризм",
            "description": "Очки за военные строения\nСкидка на Лагерь и Арсенал\nНайм отрядов увеличенного размера",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 6,
          "currentPlayerId": "player_id_celadon",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_101_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "celadon"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_102_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "celadon"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_103_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_104_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_105_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 6,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_106_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "theocracy",
            "name": "Теократия",
            "description": "Увеличенный доход храмов\nБонус к урону отрядов в городе с храмом",
            "implemented": true,
            "color": "#A9A9A9"
          },
          "round": 6,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_107_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "u_celadon_0_4_1",
          "unitHexKey": "4,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_108_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_celadon_1_6_-1",
          "unitHexKey": "6,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_109_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,-1",
          "unitId": "u_celadon_2_5_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_110_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_celadon",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_111_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fortificationism",
            "name": "Фортификационизм",
            "description": "Мгновенное строительство и скидка для крепостей\nБонус к урону рядом с крепостью",
            "implemented": true,
            "color": "#865333"
          },
          "round": 7,
          "currentPlayerId": "player_id_celadon",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_112_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 7,
        "phase": "construction",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_celadon",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_113_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 7,
        "phase": "construction",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "oligarchy",
            "name": "Олигархия",
            "description": "2 гильдий в одном городе\nУвеличенный доход гильдий",
            "implemented": true,
            "color": "#DEA806"
          },
          "round": 7,
          "currentPlayerId": "player_id_celadon",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_114_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "celadon"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_115_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "celadon"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_116_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_117_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_118_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 7,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_119_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "isolationism",
            "name": "Изоляционизм",
            "description": "Защита права первого хода\nСкидка на особые строения\nБонус к урону отрядов в своих городах",
            "implemented": true,
            "color": "#b09292"
          },
          "round": 7,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_120_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "u_celadon_0_4_1",
          "unitHexKey": "4,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_121_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_celadon_1_6_-1",
          "unitHexKey": "6,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_122_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,-1",
          "unitId": "u_celadon_2_5_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_123_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_celadon",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_124_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "militarism",
            "name": "Милитаризм",
            "description": "Увеличенный урон в ближнем бою",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 8,
          "currentPlayerId": "player_id_celadon",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_125_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 8,
        "phase": "construction",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_celadon",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_126_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 8,
        "phase": "construction",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "totalitarianism",
            "name": "Тоталитаризм",
            "description": "Очки за военные строения\nСкидка на Лагерь и Арсенал\nНайм отрядов увеличенного размера",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 8,
          "currentPlayerId": "player_id_celadon",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_127_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "celadon"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_128_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "celadon"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_129_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_130_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_131_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 8,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_132_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "industrialism",
            "name": "Индустриализм",
            "description": "Дополнительное действие\nв фазе Строительства\nСкидка на особые строения",
            "implemented": true,
            "color": "#865333"
          },
          "round": 8,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "e_133_replica",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Посёлок наш, легат. Потерь почти нет — какая это война… Сорок два меча взяли, Кесорикс связан. Остальное — бабы, старики, дети. Три сотни ртов. Ждут твоего слова.",
        "characterName": "Атилий",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m1_atilius_formal.png"
      }
    },
    {
      "id": "e_134_replica",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Не торопись со словом. Слово легата весит.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m1_barba_grim.png"
      }
    },
    {
      "id": "e_135_replica",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Закон ясен, Квинт. Мятеж против Рима: мужчин — в кандалы, остальных — на торги. Так делал отец. Так делает Рим.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m1_lucius_stern.png"
      }
    },
    {
      "id": "e_136_replica",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Господин. Господин, посмотри. Не на меня — на него посмотри. Руки. Мозоль — от верёвки. Не от меча, господин, — от верёвки. Он салазки тянул. Через горы. Я сзади толкала. Кто падал — тот оставался лежать. Мы не упали. Восемь месяцев мы не падали, господин.",
        "characterName": "Ильва",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m1_ilva_plea.png"
      }
    },
    {
      "id": "e_137_replica",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Твой муж поднял оружие на Рим, женщина.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m1_lucius_stern.png"
      }
    },
    {
      "id": "e_138_replica",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Мой муж поднял оружие на смерть. Рим просто встал между. Ты видел, господин, как горит город? Не ваш, каменный. Наш, из дерева. Он горит быстрее, чем добежать до реки. Я знаю, за сколько сгорает дом, господин. Я считала.",
        "characterName": "Ильва",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m1_ilva_plea.png"
      }
    },
    {
      "id": "e_139_replica",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Легат, обоз жрёт хлеб. Реши до заката — конвою выходить утром.",
        "characterName": "Атилий",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m1_atilius_formal.png"
      }
    },
    {
      "id": "e_140_replica",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Не смотри на меня, мальчик. Продашь — умрут медленно. Казнишь — быстро. Отпустишь — умрут свободными, тут, в поле. Мёртвым всё едино, а вот тебе — нет. Это и есть твоё «отвечать». Оно не делится на двоих… Мальчишка, кстати, смотрит не на мать. На тебя смотрит. Уже минуту.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m1_barba_grim.png"
      }
    },
    {
      "id": "e_141_replica",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "…Дайте мне подумать до заката. Рим ждал восемь месяцев — подождёт до заката.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m1_lucius_doubt.png"
      }
    },
    {
      "id": "entry_142_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "u_celadon_0_4_1",
          "unitHexKey": "4,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_143_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_celadon_1_6_-1",
          "unitHexKey": "6,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_144_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,-1",
          "unitId": "u_celadon_2_5_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_145_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_celadon",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_146_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "theocracy",
            "name": "Теократия",
            "description": "Увеличенный доход храмов\nБонус к урону отрядов в городе с храмом",
            "implemented": true,
            "color": "#A9A9A9"
          },
          "round": 9,
          "currentPlayerId": "player_id_celadon",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "e_147_replica",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Легат! Всадники с северо-востока! Пыль до неба — сотни идут! Легат… это не всадники. Они… пешие. Просто ОЧЕНЬ большие.",
        "characterName": "Дозорный",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m1_dozorny_alarm.png"
      }
    },
    {
      "id": "e_148_replica",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Шире моей ладони. На два пальца вглубь. Вот тебе и медведь в сапогах, легат.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m1_barba_grim.png"
      }
    },
    {
      "id": "e_149_replica",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "НЕТ. Нет-нет-нет…",
        "characterName": "Ильва",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m1_ilva_fear.png"
      }
    },
    {
      "id": "e_150_replica",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "ОРКИИИИ! ОРКИ ПРИШЛИИИ!",
        "characterName": "Кимврские женщины",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m1_kimvr_women.png"
      }
    },
    {
      "id": "e_151_replica",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Римлянин! Режь верёвку! Слышишь?! РЕЖЬ! Дай мне меч — любой, худший дай! Я не прошу жизни — дай умереть У НИХ НА ПУТИ, чтобы мои успели до леса! РЕЖЬ, СЫН ВИСЕВШЕГО, — твой отец бы уже РАЗРЕЗАЛ!",
        "characterName": "Кесорикс",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m1_caesorix_bound.png"
      }
    },
    {
      "id": "e_152_replica",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "(молча режет верёвку)",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m1_lucius_doubt.png"
      }
    },
    {
      "id": "e_153_replica",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Сказки, говоришь!.. СМОТРИ, РИМЛЯНИН! СМОТРИ И ЗАПОМИНАЙ МОИ СКАЗКИ!",
        "characterName": "Кесорикс",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m1_caesorix_last.png"
      }
    },
    {
      "id": "e_154_replica",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "ГРРАХХ-УР! ДРАХ! …МЯ-СО. МЯ-СО! МЯ-СО!!",
        "characterName": "Гхарзуг",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m1_gharzug_roar.png"
      }
    },
    {
      "id": "e_155_replica",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "СТЕНА! ЩИТЫ СОМКНУТЬ! Легат!.. Мальчик. Сейчас — командуй. Что бы ты ни скомандовал — командуй.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m1_barba_war.png"
      }
    },
    {
      "id": "e_156_replica",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Легион!.. СТЕНА!",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m1_lucius_command.png"
      }
    },
    {
      "id": "e_157_spawn",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "spawn",
      "player": {
        "name": "Гхарзуг",
        "color": "red",
        "factionId": "orcs",
        "selectedSkin": "orcs_default",
        "isBot": true,
        "bonus": "none"
      },
      "units": [
        {
          "id": "orc_van_1",
          "hexKey": "12,-7",
          "ownerId": "player_id_red",
          "type": "unit_d10",
          "size": 8
        },
        {
          "id": "orc_van_2",
          "hexKey": "13,-5",
          "ownerId": "player_id_red",
          "type": "unit_d10",
          "size": 7
        },
        {
          "id": "orc_van_3",
          "hexKey": "14,-7",
          "ownerId": "player_id_red",
          "type": "unit_d6",
          "size": 6
        }
      ]
    },
    {
      "id": "entry_158_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_celadon",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_159_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_160_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "agrarianism",
            "name": "Аграризм",
            "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
            "implemented": true,
            "color": "#D68A5A"
          },
          "round": 9,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_161_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "celadon"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_162_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "celadon"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_163_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_164_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_165_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_166_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_167_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "orc_van_1",
          "unitType": "unit_d10",
          "newHexKey": "10,-5"
        }
      }
    },
    {
      "id": "entry_168_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "orc_van_1",
          "fromHexKey": "12,-7",
          "toHexKey": "10,-5",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_169_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "orc_van_2",
          "unitType": "unit_d10",
          "newHexKey": "11,-5"
        }
      }
    },
    {
      "id": "entry_170_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "orc_van_2",
          "fromHexKey": "13,-5",
          "toHexKey": "11,-5",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_171_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "orc_van_3",
          "unitType": "unit_d6",
          "newHexKey": "12,-6"
        }
      }
    },
    {
      "id": "entry_172_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "orc_van_3",
          "fromHexKey": "14,-7",
          "toHexKey": "12,-6",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_173_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_174_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_175_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 9,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_176_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "barbarism",
            "name": "Варварство",
            "description": "Бесплатный наем Пехоты\nУвеличенный урон в ближнем бою\nОчки за урон",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 9,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_177_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "u_celadon_0_4_1",
          "unitHexKey": "4,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_178_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_celadon_1_6_-1",
          "unitHexKey": "6,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_179_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,-1",
          "unitId": "u_celadon_2_5_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_180_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_celadon",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_181_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_182_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "industrialism",
            "name": "Индустриализм",
            "description": "Дополнительное действие\nв фазе Строительства\nСкидка на особые строения",
            "implemented": true,
            "color": "#865333"
          },
          "round": 10,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_183_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_celadon",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_184_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_185_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "ecoanarchism",
            "name": "Экоанархизм",
            "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
            "implemented": true,
            "color": "#D68A5A"
          },
          "round": 10,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_186_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "celadon"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_187_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "celadon"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_188_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_189_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "celadon",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "celadon"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_celadon",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_190_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_191_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_192_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "orc_van_1",
          "unitType": "unit_d10",
          "newHexKey": "8,-4"
        }
      }
    },
    {
      "id": "entry_193_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "orc_van_1",
          "fromHexKey": "10,-5",
          "toHexKey": "8,-4",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_194_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "orc_van_2",
          "unitType": "unit_d10",
          "newHexKey": "9,-4"
        }
      }
    },
    {
      "id": "entry_195_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "orc_van_2",
          "fromHexKey": "11,-5",
          "toHexKey": "9,-4",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_196_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "orc_van_3",
          "unitType": "unit_d6",
          "newHexKey": "10,-5"
        }
      }
    },
    {
      "id": "entry_197_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "orc_van_3",
          "fromHexKey": "12,-6",
          "toHexKey": "10,-5",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_198_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_199_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_200_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 10,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_201_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "totalitarianism",
            "name": "Тоталитаризм",
            "description": "Очки за военные строения\nСкидка на Лагерь и Арсенал\nНайм отрядов увеличенного размера",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 10,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    }
  ],
  "objectives": [
    {
      "id": "h1_capture_victimulae",
      "type": "capture_city",
      "params": {
        "centralHexKey": "5,0"
      },
      "text": "Отбей Виктимулы",
      "isMain": true,
      "isFailure": false
    },
    {
      "id": "h1_hold_out",
      "type": "survive_rounds",
      "params": {
        "rounds": 10
      },
      "text": "Продержись до конца сцены",
      "isMain": true,
      "isFailure": false
    },
    {
      "id": "h1_units",
      "type": "units_count",
      "params": {
        "amount": 3
      },
      "text": "Собери войско в Верцеллах и держи в строю: три отряда (потери восполняй в казарме)",
      "isMain": false,
      "isFailure": false
    },
    {
      "id": "h1_mine",
      "type": "capture_key_point",
      "params": {
        "hexKey": "0,0"
      },
      "text": "Присоедини рудник Бессы: центральный квартал (4 монеты) на площадке у отвалов. Лагерь заберёт и огороды промывальщиков — без них обоз не дотянет до посёлка",
      "isMain": false,
      "isFailure": false
    },
    {
      "id": "h1_lose_vercellae",
      "type": "lose_city",
      "params": {
        "centralHexKey": "-7,1"
      },
      "text": "Не потеряй Верцеллы",
      "isMain": false,
      "isFailure": true
    }
  ]
};

export default mission;
